export const PASSPORT_TIP = '温馨提示：与百度App、贴吧、云盘、知道等产品通用。';
export const UC_TIP = '温馨提示：与百度营销、百度网盟、百度联盟、百度统计、百度司南等产品账号通用。';

export enum LoginType {
    UC = 'UC',
    PASSPORT = 'PASSPORT',
    NORMAL_PASSPORT = 'NORMAL_PASSPORT',
    SMS_PASSPORT = 'SMS_PASSPORT',
    QRCODE_PASSPORT = 'QRCODE_PASSPORT',
}

export enum ThirdType {
    WECHAT_PASSPORT = '42',
    QQ_PASSPORT = '15',
    WEIBO_PASSPORT = '2',
}

export enum ABTestUserType {
    A = 'A',
    B = 'B',
}
